// import { CallToActionSharp } from "@mui/icons-material";
import { createSlice } from "@reduxjs/toolkit"

const alertSlice = createSlice({
    name: "alerts",
    initialState: {
        alertOpen: false,
        alertSeverity: 'error',
        alertMessage: ''
    },
    reducers: {
        showAlert(state, action) {
            const { severity, message } = action.payload;
            return { ...state, alertOpen: true, alertSeverity: severity, alertMessage: message }
        },
        closeAlert(state) {
            return { ...state, alertOpen: false, alertMessage: '' }
        }
    }
});

export const { showAlert, closeAlert } = alertSlice.actions;
export default alertSlice.reducer;